export class PhoneHostImportRecord {
    Name: string
    Number: string
    Errors: Record<string, string>
}

export class PhoneHostImportReportSummary {
    Id: string
    FileName: string
    Status: string
    CreatedDateTime: string
    CreatedBy: string
    SavedCount: number
    IgnoredCount: number
}

export class PhoneHostImportReport {
    Id: string
    IsDeleted: boolean
    CreatedDateTime: string
    CreatedById: string
    CreatedBy: string
    FileName: string
    SavedRecords: PhoneHostImportRecord[]
    IgnoredRecords: PhoneHostImportRecord[]
    Status: string
}

const asText = (value: any) => value == null ? "" : String(value)

const countOf = (records: any, count: any) => {
    if (typeof count === "number") return count
    if (Array.isArray(records)) return records.length
    if (typeof records === "number") return records
    return 0
}

const mapRecord = (record: any): PhoneHostImportRecord => ({
    Name: asText(record?.name ?? record?.Name),
    Number: asText(record?.number ?? record?.Number),
    Errors: record?.errors || record?.Errors || {}
})

const mapRecords = (records: any): PhoneHostImportRecord[] => {
    return Array.isArray(records) ? records.map(mapRecord) : []
}

export const mapToPhoneHostImportReportSummary = (report: any): PhoneHostImportReportSummary => ({
    Id: asText(report?.id ?? report?.Id),
    FileName: asText(report?.fileName ?? report?.FileName),
    Status: asText(report?.status ?? report?.Status),
    CreatedDateTime: asText(report?.createdDateTime ?? report?.CreatedDateTime),
    CreatedBy: asText(report?.createdBy ?? report?.CreatedBy),
    SavedCount: countOf(report?.savedRecords ?? report?.SavedRecords, report?.savedCount ?? report?.SavedCount),
    IgnoredCount: countOf(report?.ignoredRecords ?? report?.IgnoredRecords, report?.ignoredCount ?? report?.IgnoredCount)
})

export const mapToPhoneHostImportReport = (report: any): PhoneHostImportReport => ({
    Id: asText(report?.id ?? report?.Id),
    IsDeleted: !!(report?.isDeleted ?? report?.IsDeleted),
    CreatedDateTime: asText(report?.createdDateTime ?? report?.CreatedDateTime),
    CreatedById: asText(report?.createdById ?? report?.CreatedById),
    CreatedBy: asText(report?.createdBy ?? report?.CreatedBy),
    FileName: asText(report?.fileName ?? report?.FileName),
    SavedRecords: mapRecords(report?.savedRecords ?? report?.SavedRecords),
    IgnoredRecords: mapRecords(report?.ignoredRecords ?? report?.IgnoredRecords),
    Status: asText(report?.status ?? report?.Status)
})
